'use client'

import classNames from 'classnames'
import Link from 'next/link'

import { isTag } from '@/features/tag-filter/config' // TODO: не должно импортировать соседнюю фичу!
import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

type PostLabelProps = {
    tag: string
    selected?: boolean
}

export function PostTag({ tag, selected }: PostLabelProps) {
    const { i18n } = useI18n()

    if (!tag) {
        return null
    }

    const tagHref = selected ? '/' : (`/${tag}` as const)
    const tagClassName = isTag(tag) ? `tag-${tag}` : 'tag-unknown'

    return (
        <section style={{ width: 'fit-content' }}>
            <Link href={tagHref} style={{ textDecoration: 'none' }} prefetch={false}>
                <p className={styles.postFullTagParagraph}>
                    <span className={classNames(styles.postFullTag, tagClassName)}>
                        {isTag(tag) ? i18n[`TAG_${tag}`] : tag}
                    </span>
                </p>
            </Link>
        </section>
    )
}
